export default __webpack_public_path__ + "static/media/arrow-right.e35329ca.svg";